<template>
	<div id="downLoad">
		<div :class="scrollFlag?'topLan1':'topLan'" >
			<img  @click="jumpToIndex" class="CoBrand" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link :class="scrollFlag?'box1':'box'":to="{path: 'index'}">首页</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'platform'}">电商平台</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'about'}">关于我们</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'newsCenter'}">新闻中心</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'recruit'}">人才招聘</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'downLoad'}">下载APP
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</router-link>
			</div>
		</div>
		
		<div id="id1" style="width:100%;display: flex;flex-direction: column;">
			<img style="width: 100%;" mode="widthFix" src="../../static/downLoadPic/img_web07_banner1.png" />
			<!-- <div style="width: 100%;height: 10px; background-color: #242B34;"></div> -->
		</div>
		
		
		<bottom-area style="margin-top: -10px;"></bottom-area>
	</div>
</template>

<script>
	import bottomArea from "../components/bottomArea.vue"
	export default {
		components: {
			bottomArea
		},
		data() {
			return {
				windowHeight: String(document.documentElement.clientHeight),
				scrollFlag:false,
			}
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll () {
			  let _this=this;
			  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			  // console.log(scrollTop)
			  console.log(scrollTop)
			  if(scrollTop){
			    _this.scrollFlag=true
			  }else{
			    _this.scrollFlag=false
			  }
			},
			jumpToIndex(){
				this.$router.push({
					name: 'index',
					params: {}
				});
			}
		}
	}
</script>

<style scoped>
	html,
	body,
	#downLoad {
		width: 100%;
		height: 100%;
		text-align: left;
	}
	.box2{
		color: #467CFD !important;
		position: relative;
		height: 122px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		line-height: 122px;
		text-align: center;
	}
</style>